// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"60957":"a6bb4d012f829128","74724":"b6323009d4472833","96325":"431d3ac0624a38a3"}[chunkId] + ".css";
};